import axios from "axios";
import { api, setTokens, getRefreshToken } from "./client";

const BASE = "/api/admin";

export async function login(username, password) {
  const res = await axios.post(`${BASE}/auth/login`, { username, password });
  setTokens(res.data.access_token, res.data.refresh_token);
  return res.data;
}

export async function refreshAuth() {
  const refreshToken = getRefreshToken();
  if (!refreshToken) throw new Error("No refresh token");
  const res = await axios.post(`${BASE}/auth/refresh`, {
    refresh_token: refreshToken,
  });
  setTokens(res.data.access_token, res.data.refresh_token);
  return res.data;
}

export const fetchClients = () => api.get(`${BASE}/clients`);
export const fetchConfigDefaults = () => api.get(`${BASE}/config-defaults`);
export const createClient = (data) => api.post(`${BASE}/clients`, data);
export const updateClient = (id, data) =>
  api.patch(`${BASE}/clients/${id}`, data);
export const deleteClient = (id) => api.delete(`${BASE}/clients/${id}`);

export const fetchDocuments = (clientId) =>
  api.get(`${BASE}/clients/${clientId}/documents`);
export const uploadDocuments = (clientId, formData) =>
  api.post(`${BASE}/clients/${clientId}/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 600000,
  });
export const deleteDocument = (clientId, source) =>
  api.delete(
    `${BASE}/clients/${clientId}/documents/${encodeURIComponent(source)}`,
  );
export const cancelDocument = (clientId, source) =>
  api.post(
    `${BASE}/clients/${clientId}/documents/${encodeURIComponent(source)}/cancel`,
  );
export const fetchChunks = (clientId, source) =>
  api.get(
    `${BASE}/clients/${clientId}/documents/${encodeURIComponent(source)}/chunks`,
  );

export const resyncDatabase = (clientId) =>
  api.post(`${BASE}/clients/${clientId}/database/resync`);
export const wipeDatabase = (clientId) =>
  api.delete(`${BASE}/clients/${clientId}/database/wipe`);
export const fetchDatabaseOverview = () => api.get(`${BASE}/database/overview`);
export const clearDatabase = () => api.delete(`${BASE}/database/clear`);
export const fetchErrorLogCount = () => api.get(`${BASE}/logs/error-count`);

export const fetchSubclients = (clientId) =>
  api.get(`${BASE}/clients/${clientId}/subclients`);
export const createSubclient = (clientId, data) =>
  api.post(`${BASE}/clients/${clientId}/subclients`, data);
export const updateSubclient = (clientId, subId, data) =>
  api.patch(`${BASE}/clients/${clientId}/subclients/${subId}`, data);
export const deleteSubclient = (clientId, subId) =>
  api.delete(`${BASE}/clients/${clientId}/subclients/${subId}`);

export const resetPortalPassword = (clientId) =>
  api.post(`${BASE}/clients/${clientId}/portal-password/reset`);

export const resetClientMetrics = (clientId) =>
  api.post(`${BASE}/clients/${clientId}/reset-metrics`);

export const setClientPaused = (clientId, paused) =>
  api.post(`${BASE}/clients/${clientId}/pause`, { paused });

export const fetchGlobalStats = () => api.get(`${BASE}/stats/overview`);
export const fetchAnalytics   = () => api.get(`${BASE}/stats/analytics`);
